import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <section className="section section--dark">
      <div className="wrap">
        <span className="eyebrow eyebrow--dark">404</span>
        <h2>That page isn&rsquo;t here</h2>
        <p className="hero__sub">
          The link may be old or mistyped. The fleet and rates are on the
          main page.
        </p>
        <div className="hero__actions">
          <Link className="btn btn--primary" to="/">
            Back to the fleet
          </Link>
        </div>
      </div>
    </section>
  )
}
